import React, { FunctionComponent } from 'react'
import * as S from './styled'
import { ReactComponent as Logo } from '../../components/atoms/Icons/logo.svg'
import { Link } from 'react-router-dom'

type OwnProps = {}

type Props = OwnProps

// Confirm the link is a sign-in with email link.

export const SignInWithVerification: FunctionComponent<Props> = () => {
  return (
    <S.Wrapper>
      <S.Container>
        <Logo height="125" viewBox="0 0 550 550" />
        <S.Title>Välkommen till Agripare!</S.Title>

        <S.Paragraph>
          Din e-post address är nu verifierad. Klicka <Link to="/">här</Link> för att komma igång!
        </S.Paragraph>
      </S.Container>
    </S.Wrapper>
  )
}

export default SignInWithVerification
